import React from 'react'
import { ErrorBoundary } from 'secondstep-components'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'
import SchoolSummary from 'pages/SchoolSummary'
import GradeView from 'pages/K8GradeView'
import { PageWrapper } from './component.styles'

const K8Report = ({
  entry,
  gradeEmptyDisplay,
  match,
  navigationHandler,
  schoolEmptyDisplay,
}) => {
  return (
    <ErrorBoundary>
      <PageWrapper>
        <Switch>
          <Route
            path={`${match.path}/:unitSection/:gradeName`}
            render={routeProps => {
              return (
                <GradeView
                  // TODO [LEARN-16417]: treeshake entry to give component only what it needs
                  entry={entry}
                  gradeEmptyDisplay={gradeEmptyDisplay}
                  gradeParam={routeProps.match.params.gradeName}
                  k8ReportUnitSection={routeProps.match.params.unitSection}
                  location={routeProps.location}
                  navigationHandler={navigationHandler}
                />
              )
            }}
          />
          <Route
            path={`${match.path}/:unitSection`}
            render={routeProps => (
              <SchoolSummary
                entry={entry}
                k8ReportUnitSection={routeProps.match.params.unitSection}
                navigationHandler={navigationHandler}
                schoolEmptyDisplay={schoolEmptyDisplay}
              />
            )}
          />
        </Switch>
      </PageWrapper>
    </ErrorBoundary>
  )
}

K8Report.propTypes = {
  entry: PropTypes.object,
  gradeEmptyDisplay: PropTypes.object,
  match: PropTypes.object,
  navigationHandler: PropTypes.func,
  schoolEmptyDisplay: PropTypes.object,
  siteId: PropTypes.string,
}

export default K8Report
